
export const STRIPE_PUBLIC_KEY = "pk_live_51RygEOBkGX2e0AzpVc6kP3Fymaj7kK8Ncx49zOV1Z03Rzo15GycsRiXCdAVvFIRRiv3DFSMZ6h9wxW9HfeTzQjYE002R0rB881";
